import React, { useState } from "react";
import Spinner from "../Components/Spinner";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";
import Footer from "../Website/Footer";

const Waitlist = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const url = "https://projecte8-backend-195291847042.europe-west1.run.app/api/early-access";

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState("");

    const isValidEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // const handleSubmit = async () => {
    //     if (!firstName || !lastName || !email || !isValidEmail(email)) {
    //         setMessage(t.waitlist.errors.invalidEmail);
    //         return;
    //     }

    //     setLoading(true);
    //     setMessage("");

    //     try {
    //         const response = await fetch(url, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({
    //                 name: firstName,
    //                 last_name: lastName,
    //                 email: email,
    //             }),
    //         });

    //         const data = await response.json();

    //         if (response.ok && data.status === "OK") {
    //             setTimeout(() => {
    //                 setSuccess(true);
    //                 setFirstName("");
    //                 setLastName("");
    //                 setEmail("");
    //             }, 1500);
    //         } else {
    //             setMessage(data.message || t.waitlist.errors.failedSignup);
    //         }
    //     } catch (error) {
    //         setLoading(false);
    //         setMessage(t.waitlist.errors.serverError);
    //     } finally {
    //         setTimeout(() => {
    //             setLoading(false);
    //         }, 1500);
    //     }
    // };

    // const isDisabled =
    //     !firstName || !lastName || !email || !isValidEmail(email) || loading;


    const navigateUrl = () => {
        window.location.href = "https://www.erioon.com/terms-and-conditions";
    }

    const navigateSignUp = () => {
        window.location.href = "https://www.projecte8.com/register";
    }

    return (
        <div className="waitlist_cont">
            <div className="waitlist_form_cont">
                <div className="success_message fade-in">
                    <i className="success_message_icon fa-solid fa-check"></i>
                    <p className="success_title">{t.waitlist.not_available.title}</p>
                    <p className="success_subtitle">{t.waitlist.not_available.subtitle}</p>
                    <div className="input_cont">
                    <button
                        className={`btn_reg btn_reg_enabled`}
                        onClick={navigateSignUp}
                        >
                        {loading ? <Spinner loading={loading} /> : t.waitlist.form.submitBtn}
                    </button>
                        </div>
                </div>
            </div>
            {/* <div className="waitlist_form_cont">
                {success ? (
                    <div className="success_message fade-in">
                        <i className="success_message_icon fa-solid fa-check"></i>
                        <p className="success_title">{t.waitlist.success.title}</p>
                        <p className="success_subtitle">{t.waitlist.success.subtitle}</p>
                        <button
                            className="back_btn_home"
                            onClick={() => navigate("/")}
                        >
                            <i className="fa-solid fa-chevron-left"></i> {t.waitlist.success.backBtn}
                        </button>
                    </div>
                ) : (
                    <>
                        <p className="waitlist_form_cont_title fade-in">{t.waitlist.form.title}</p>
                        <p className="waitlist_form_cont_subtitle fade-in">{t.waitlist.form.subtitle}</p>
                        <div className="input_cont fade-in">
                            <div className="double_input">
                                <input
                                    className="input_reg"
                                    placeholder={t.waitlist.form.firstNamePlaceholder}
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                                <input
                                    className="input_reg"
                                    placeholder={t.waitlist.form.lastNamePlaceholder}
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                            <input
                                className="input_reg"
                                placeholder={t.waitlist.form.emailPlaceholder}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <button
                                className={`btn_reg ${isDisabled ? "btn_reg_disable" : "btn_reg_enabled"}`}
                                onClick={handleSubmit}
                                disabled={isDisabled}
                            >
                                {loading ? <Spinner loading={loading} /> : t.waitlist.form.submitBtn}
                            </button>
                            <p className="privacy_policy" onClick={navigateUrl}>{t.waitlist.form.privacy}</p>
                            {message && <p className="message fade-in">{message}</p>}
                        </div>
                    </>
                )}
            </div> */}
            <Footer />
        </div>
    );
};

export default Waitlist;
